/**
 * @desc  [自定义校验规则]
 * @example
 *  import { validateRule } from "@/utils/validateRules";
 *  rules: [
 *     { validator: validateRule.emailValue, trigger: 'blur'}
 *  ]
 */
import {checkSocialCreditCode, validatenull} from './validate'

export const rule = {
	/**
	 * 校验 请输入英文、数字
	 */
	validatorAbcNum(rule, value, callback) {
		let content = /^[a-zA-Z0-9]+$/
		if (value && !content.test(value)) {
			callback(new Error('请输入英文、数字'))
		} else {
			callback()
		}
	},

	/**
	 * 校验 请输入中文、英文、数字包括下划线
	 * 名称校验
	 */
	validatorNameCn(rule, value, callback) {
		let acount = /^[\u4E00-\u9FA5A-Za-z0-9_]+$/
		if (value && !acount.test(value)) {
			callback(new Error('请输入中文、英文、数字包括下划线'))
		} else {
			callback()
		}
	},
	/**
	 * 校验 请输入中文、英文、数字包括下划线
	 * 名称校验
	 */
	validatorKey(rule, value, callback) {
		let acount = /^[A-Z_]+$/
		if (value && !acount.test(value)) {
			callback(new Error('请输入大写英文、下划线'))
		} else {
			callback()
		}
	},

	/**
	 * 校验首尾空白字符的正则表达式
	 *
	 */
	checkSpace(rule, value, callback) {
		let longrg = /[^\s]+$/
		if (!longrg.test(value)) {
			callback(new Error('请输入非空格信息'))
		} else {
			callback()
		}
	},

	/**
	 * 校验用户名）
	 */
	validatorUserName(rule, value, callback) {
		let regAll = /^[a-zA-Z0-9]+$/
		let regLetter = /^[a-zA-Z]+$/
		let regNumber = /^[0-9]+$/
		if (regLetter.test(value) || regNumber.test(value) || regAll.test(value)) {
			callback()
		} else {
			callback(new Error('登录名由4-20位英文字母或数字组成'))
		}
	},

	/**
	 * 校验密码（8-20位英文字母加数字）
	 */
	validatorPass(rule, value, callback) {
		let regAll = /^[a-zA-Z0-9]+$/
		let regLetter = /^[a-zA-Z]+$/
		let regNumber = /^[0-9]+$/
		if (regAll.test(value)) {
			if (regLetter.test(value) || regNumber.test(value)) {
				callback(new Error('密码由8-20位英文字母加数字组成'))
			} else {
				callback()
			}
		} else {
			callback(new Error('密码由8-20位英文字母加数字组成'))
		}
	},

	validatorMobile(rule, value, callback) {
		const reg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/
		if (value == '' || value == undefined || value == null) {
			callback()
		} else {
			if (!reg.test(value) && value != '') {
				callback(new Error('请输入正确的电话号码'))
			} else {
				callback()
			}
		}
	},

	validatorEmpNum(rule, value, callback) {
		if (value <= 0 || value > 2000) {
			callback(new Error('输入数值范围[1,2000]'))
		}
		callback()
	},

	validatorIdNo(rule, value, callback) {
		if (validatenull(value)) {
			// callback(new Error('请输入身份证号'));
			callback()
		} else {
			if (!isIdCardNoValid(value + '')) {
				callback(new Error('请输入正确的身份证号'))
			} else {
				callback()
			}
		}
	},

	validatorCreditCode(rule, value, callback) {
		let result = checkSocialCreditCode(value)

		if (!result.isPass) {
			callback(new Error(result.errorMessage))
		} else {
			callback()
		}
	},
	validatorCreditCodeNotFifteen(rule, value, callback) {
		let result = checkSocialCreditCode(value, false)

		if (!result.isPass) {
			callback(new Error(result.errorMessage))
		} else {
			callback()
		}
	},

	/**
	 *
	 */
	validatorNumber(rule, value, callback) {
		let regNumber = /^[0-9]\d*$/
		if (regNumber.test(value)) {
			callback()
		} else {
			callback(new Error('输入内容不正确'))
		}
	},
}

export function isIdCardNoValid(code) {
	let city = {
		11: '北京',
		12: '天津',
		13: '河北',
		14: '山西',
		15: '内蒙古',
		21: '辽宁',
		22: '吉林',
		23: '黑龙江 ',
		31: '上海',
		32: '江苏',
		33: '浙江',
		34: '安徽',
		35: '福建',
		36: '江西',
		37: '山东',
		41: '河南',
		42: '湖北 ',
		43: '湖南',
		44: '广东',
		45: '广西',
		46: '海南',
		50: '重庆',
		51: '四川',
		52: '贵州',
		53: '云南',
		54: '西藏 ',
		61: '陕西',
		62: '甘肃',
		63: '青海',
		64: '宁夏',
		65: '新疆',
		71: '中国台湾',
		81: '中国香港',
		82: '中国澳门',
		91: '国外 ',
	}
	let tip = ''
	code = code.replace('x', 'X')
	if (code.length !== 18) {
		return false
	}
	if (!code || !/^\d{6}(18|19|20)?\d{2}(0[1-9]|1[012])(0[1-9]|[12]\d|3[01])\d{3}(\d|X)$/i.test(code)) {
		return false
	}
	if (!city[code.substr(0, 2)]) {
		// tip = "地址编码错误";
		// alert(tip);
		return false
	}

	if (code.length === 18) {
		let sBirthday = code.substr(6, 4) + '-' + Number(code.substr(10, 2)) + '-' + Number(code.substr(12, 2))
		let d = new Date(sBirthday.replace(/-/g, '/'))
		if (sBirthday !== d.getFullYear() + '-' + (d.getMonth() + 1) + '-' + d.getDate()) {
			// tip = "非法生日";
			// alert(tip);
			return false
		}
	}
	//18位身份证需要验证最后一位校验位
	if (code.length === 18) {
		code = code.split('')
		//∑(ai×Wi)(mod 11)
		//加权因子
		let factor = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2]
		//校验位
		let parity = [1, 0, 'X', 9, 8, 7, 6, 5, 4, 3, 2]
		let sum = 0
		let ai = 0
		let wi = 0
		for (let i = 0; i < 17; i++) {
			ai = code[i]
			wi = factor[i]
			sum += ai * wi
		}
		if (parity[sum % 11] != code[17]) {
			// tip = "校验位错误";
			// alert(tip);
			return false
		}
	}
	return true
}
